<template>
    <div class="bg-indigo-50 p-5 rounded">
        <div class="font-bold">Язык устройства</div>
        <div class="mt-2" v-if="this.languages">
            <div class="w-6/12 mt-6 form-select-reset">
                <v-select class="without-ring" label="name" multiple :reduce="el => el.label"
                          :options="this.languages" v-model="selectedLanguages">
                </v-select>
            </div>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import {mapActions, mapState} from "pinia";
import {languagesStore} from "@/scripts/store/languages.store";

export default {
    components: {vSelect},

    props: {
        modelValue: {
            required: true
        }
    },

    watch: {
        selectedLanguages() {
            if (this.selectedLanguages.length > 0) {
                this.$emit('update:modelValue', {languages: this.selectedLanguages})
            } else {
                this.$emit('update:modelValue', {})
            }
        }
    },

    data() {
        return {
            availableLanguages: [],
            selectedLanguages: [],
        };
    },

    computed: {
        ...mapState(languagesStore, ['languages'])
    },

    mounted() {
        if (this.modelValue.languages && this.modelValue.languages.length > 0) {
            this.selectedLanguages = this.modelValue.languages
        } else {
            this.selectedLanguages = ['ru']
        }

        this.loadLanguages()
    },

    methods: {
        ...mapActions(languagesStore, ['loadLanguages'])
    }
}
</script>

<style lang="scss">
.form-select-reset {
    input {
        background-color: inherit;
        border: none;
        box-shadow: none;
        --tw-ring-shadow: 0 0 #000 !important;
    }

    *:focus {
        outline: none !important;
        border: none !important;
    }
}
</style>
